<template>
  <td
    :class="{ 'table-danger': profile !== null && profile.deleted_at !== null }"
  >
    <div>
      <component :is="renderComponent" :to="link" v-if="profile !== null">
        <img height="45" width="45" class="rounded-circle mr-2" :src="src" />
        {{ profile.name }}
        <i v-if="profile.sex == 'männlich'" class="fas fa-mars male-icon"></i>
        <i
          v-else-if="profile.sex == 'weiblich'"
          class="fas fa-venus female-icon"
        ></i>
      </component>
      <div v-else-if="showAsDeleted" class="d-flex align-items-center">
        <div
          class="profile-image rounded-circle mr-2 bg-light d-flex align-items-center justify-content-center"
        >
          <i class="far fa-times-circle"></i>
        </div>
        Gelöscht
      </div>
      <div v-else>
        zufällig
      </div>
    </div>
  </td>
</template>

<script lang="babel">
export default {
    props: ['model', 'content'],
    computed: {
      src () {
        return (this.profile !== null || this.profile.primary_image_url !== null) ?
        `${this.profile.primary_image_url}?width=45&height=45` :
        "https://via.placeholder.com/45";
      },
      profile () {
        if((typeof this.content === 'object')&&
        (this.content !== null)){
          return this.content;
        }else if(this.model.customer_profile !== undefined){
          return this.model.customer_profile;
        }

        return 'user_id' in this.model && 'country' in this.model ? this.model : null;
      },
      link () {
        return this.profile.is_fake ?
          `/fake/kartei/${this.profile.id}` :
          `/mitglieder/kartei/${this.profile.id}`;
      },
      renderComponent() {
        if (!this.$route) {
          return "div";
        } else {
          return "router-link";
        }
      },
      showAsDeleted() {
        return !window.location.host.startsWith('admin-panel');
      }
    },
};
</script>

<style lang="scss" scoped>
.male-icon {
  color: $male;
}
.female-icon {
  color: $female;
}

.profile-image {
  width: 45px;
  height: 45px;
}
</style>
